import { useState } from "react";
import ThemedDialog from "../Components/ThemedDialog";
import { confirmable, createConfirmation } from "react-confirm";
import { TextField, Button, DialogActions, DialogContent, DialogTitle} from "@mui/material";

const MAX_LENGTH = 255;

const NoteDialog = ({ show, proceed }) => {
	const [text, setText] = useState("");

	const handleChange = (event) => {
		const newValue = event.target.value;
		if (newValue.length <= MAX_LENGTH) {
			setText(newValue);
		}
	};

	return (
		<ThemedDialog open={show} maxWidth="sm" fullWidth onClose={proceed}>
			<DialogTitle>
				Notiz hinzufügen
			</DialogTitle>
			<DialogContent>
				<TextField
					variant="outlined"
					label="Bemerkung"
					required
					fullWidth
					value={text}
					onChange={handleChange}
					autoFocus
					margin="normal"
					multiline
					rows={4}
					helperText={`${text.length}/${MAX_LENGTH} Zeichen`}
					error={text.length >= MAX_LENGTH}
				/>
			</DialogContent>
			<DialogActions>
				<Button
					variant="outlined"
					color="secondary"
					href=""
					onClick={proceed}
				>
					Abbrechen
				</Button>
				<Button
					variant="outlined"
					color="primary"
					href=""
					onClick={() => proceed({ ok: 1, text })}
				>
					OK
				</Button>
			</DialogActions>
		</ThemedDialog>
	);
};

export default (options) => {
	const dialog = confirmable(props => <NoteDialog {...props} {...options} />);
	return createConfirmation(dialog)();
};
